import SplitPane from "react-split-pane";
import "./resizer.css";

export default SplitPane;
